import React from 'react';
import Calculator from '@/pages/Calculator';

const FeedsSpeeds = () => {
  return (
    <div className="space-y-6" data-testid="feeds-speeds-page">
      <div className="panel-header">
        <div>
          <div className="panel-title">Tools / Feeds &amp; Speeds</div>
          <h1 className="text-3xl md:text-4xl font-semibold tracking-tight mt-2">Feeds &amp; Speeds Calculator</h1>
          <p className="text-sm md:text-base text-[var(--text-secondary)] mt-2 max-w-2xl">
            Use the CNC-Helpdesk job calculator to set spindle speed, feed rate, pass depth, and stepover
            for your current material, tool, and spindle.
          </p>
        </div>
      </div>
      <div className="panel">
        <Calculator />
      </div>
    </div>
  );
};

export default FeedsSpeeds;
